const testRouter = [
    {
        path: '/test',
        component: () => import('@/layout/LayoutIndex.vue'),
        meta: { title: '测试', icon: 'system', requireAuth: true },
        name: 'test',
        redirect: '/home',
        children: [
          {
            path: '/test/testAddConstantRoutesIndex',
            component: () => import('@/views/test/testAddConstantRoutes/testAddConstantRoutesIndex.vue'),
            name: 'testAddConstantRoutesIndex',
            meta: { title: '测试菜单有的页', requireAuth: true }
          },
         
        ]
    },
]

export default testRouter;